export enum AssetKind {
    GENERAL = 'GENERAL',
    HOME = 'HOME',
    OTHER= 'OTHER',
}
